import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { CalendarPlus, LayoutTemplate, Pencil, Proportions, QrCode, Wand2 } from 'lucide-react'
import * as m from '~/paraglide/messages'
import { FeatureCard } from '~/shared/ui/feature-card'
import { PageHeader } from '~/widgets/page-header'

export const Route = createFileRoute('/dashboard/ai-studio/')({
  component: AiStudio,
})

function AiStudio() {
  const navigate = useNavigate()

  const features = [
    {
      icon: CalendarPlus,
      title: m.eventCreator(),
      description: m.eventCreatorDescription(),
      onClick: () => navigate({ to: '/dashboard/events/create' }),
    },
    {
      icon: Proportions,
      title: m.formatConverter(),
      description: m.formatConverterDescription(),
      onClick: () => navigate({ to: '/dashboard/ai-studio/format-converter' }),
    },
    {
      icon: Pencil,
      title: m.editPicture(),
      description: m.editPictureDescription(),
      onClick: () => navigate({ to: '/dashboard/ai-studio/edit-picture' }),
    },
    {
      icon: Wand2,
      title: m.refineTool(),
      description: m.refineToolDescription(),
      onClick: () => navigate({ to: '/dashboard/ai-studio/refine' }),
    },
    {
      icon: QrCode,
      title: m.qrTool(),
      description: m.qrToolDescription(),
      onClick: () => navigate({ to: '/dashboard/ai-studio/qr' }),
    },
    {
      icon: LayoutTemplate,
      title: m.flyerTool(),
      description: m.flyerToolDescription(),
      onClick: () => navigate({ to: '/dashboard/ai-studio/flyer' }),
    },
  ]

  return (
    <div className="space-y-6">
      <PageHeader title={m.aiStudio()} description={m.aiStudioDescription()} />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((feature) => (
          <FeatureCard
            key={feature.title}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
            underDevelopment={!feature.onClick}
            onClick={feature.onClick}
          />
        ))}
      </div>
    </div>
  )
}
